import { render, staticRenderFns } from "./buckets.vue?vue&type=template&id=4565e33a&"
import script from "./buckets.vue?vue&type=script&lang=js&"
export * from "./buckets.vue?vue&type=script&lang=js&"
import style0 from "./buckets.vue?vue&type=style&index=0&id=4565e33a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports